import Notification, {
  IPCameraEvent,
  NotificationEventType,
  SamplePointEvent
} from 'types/models/notification';
import { SiteId } from 'types/models/site';

export const getNotificationSiteId = (notification: Notification): SiteId | null => {
  if (notification.eventType === NotificationEventType.SAMPLE_POINT_EVENT) {
    const event = notification.event as SamplePointEvent;
    return event.samplePoint.siteId;
  } else if (notification.eventType === NotificationEventType.IP_CAMERA_EVENT) {
    const event = notification.event as IPCameraEvent;
    return event.ipCamera.siteId;
  }

  return null;
};